function buildURL(baseUrl, params) {
    // Check if baseUrl is not empty
    if (!baseUrl.trim()) {
        console.error('Base URL cannot be empty');
        return;
    }

    // Check if params is an object
    if (typeof params !== 'object' || params === null) {
        console.error('Params must be an object');
        return;
    }

    // Create an array to hold the URL parameters
    let urlParams = [];

    // Loop through the params object and build the parameter strings
    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            let encodedKey = encodeURIComponent(key);
            let encodedValue = encodeURIComponent(params[key]);
            urlParams.push(`${encodedKey}=${encodedValue}`);
        }
    }

    // Combine the base URL and parameters
    let fullUrl = baseUrl;
    if (urlParams.length > 0) {
        fullUrl += '?' + urlParams.join('&');
    }

    return fullUrl;
}
export default buildURL;
